import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=5a9009e8&scoped=true"
import script from "./MainNav.vue?vue&type=script&lang=ts"
export * from "./MainNav.vue?vue&type=script&lang=ts"
import style0 from "./MainNav.vue?vue&type=style&index=0&id=5a9009e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9009e8",
  null
  
)

export default component.exports